export default import.meta.ROLLDOWN_FILE_URL_Jc3ANHuItLy9rk7IiWFubg